export const GenderType = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',

    values: () => {
        return ['MALE', 'FEMALE'];
    }
}